import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <header className="fixed top-0 w-full bg-black/50 backdrop-blur-md border-b border-gray-800">
        <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-600 text-transparent bg-clip-text">
            Verdyct
          </Link>
        </nav>
      </header>
      <main className="container mx-auto px-4 pt-32 pb-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-600 text-transparent bg-clip-text">Privacy Policy</h1>
          
          <div className="space-y-6 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Information We Collect</h2>
              <p>We collect information you provide directly to us, including:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Account information (email, password)</li>
                <li>User-generated content (debate topics and interactions)</li>
                <li>Payment information when you subscribe to premium features</li>
                <li>Usage data and analytics</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide and improve our AI debate service</li>
                <li>To process your transactions and manage your account</li>
                <li>To communicate with you about service updates</li>
                <li>To analyze usage patterns and optimize our platform</li>
                <li>To protect against misuse or abuse of our service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Data Storage and Security</h2>
              <p>We use Firebase for secure data storage and authentication. Your data is protected using industry-standard encryption and security measures.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Information Sharing</h2>
              <p>We do not sell your personal information. We may share your information:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>With service providers who assist in operating our platform</li>
                <li>When required by law or to protect our rights</li>
                <li>When you choose to share debate content publicly</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Your Rights</h2>
              <p>You can:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Access and update your personal information</li>
                <li>Request deletion of your account and data</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Cookies and Analytics</h2>
              <p>We use cookies and similar technologies to analyze usage patterns and provide a better user experience. You can control cookie settings through your browser.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Changes to Privacy Policy</h2>
              <p>We may update this privacy policy from time to time. We will notify you of any material changes via email or through the platform.</p>
            </section>
          </div>
        </div>
      </main>
    </div>
  )
}